import localKey from "./localKey";

const devApiUrl = "/";

// const proApiUrl = "https://admin.api.fxzb.vip";
const proApiUrl = "https://dev.admin.api.fxzb.vip";
// const proApiUrl = 'http://192.168.110.201:8200';


const nodeDevEnv = process.env.NODE_ENV === "development";

export default {
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    siteName: "管理后台",
    minSiteMame: "C",
    version: "v1.0.0",
    apiPrefix: "",
    timeout: 10000,
    cookiesExpires: 7,
    requestRetry: 4,
    requestRetryDelay: 800,
    tokenKey: "Authorization",
    userInfoKey: "USER_INFO",
    ...localKey,
};
